export const PREFERRED_DASHBOARD_APP_TITLE = 'User Info';

export const OPEN_PREFERRED_DASHBOARD_APP_EVENT =
  'openPreferredConversationSidebarDashboardApp';
